import React, {ChangeEvent, FC, useState} from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import {InputGroup} from "react-bootstrap";
import {useImageUploadController} from "../../../controllers/useImageUploadController";
import ToolTip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import {useParams} from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";

interface PropsType {
    id: string;
    value: string;
    handleOnChange: (value: string) => void;
    dataTestId?: string;
}

export const ImageInput: FC<PropsType> = ({id, value, handleOnChange, ...props}) => {

    const controller = useImageUploadController();
    const routeParams = useParams<{ projectId: string }>();
    const [fileSelected, setFileSelected] = useState<File>();
    const [fileUploaded, setFileUploaded] = useState(!!value);
    const [uploadInProgress, setUploadInProgress] = useState(false);
    const [returnedFilePath, setReturnedFilePath] = useState<string>(value);

    const saveFileSelected = (e: ChangeEvent<HTMLInputElement>) => e.target.files != null && setFileSelected(e.target.files[0]);

    const uploadFile = async () => {
        if (fileSelected != null) {

            setUploadInProgress(true);
            // routeParams.projectId should never be null at this point. Not sure why it's suggesting it is here, and elsewhere it isn't. Type assertion added to hide warning.
            const uploadImageRequest = await controller.handleImageUpload(fileSelected, routeParams.projectId as string);

            setUploadInProgress(false);

            if (uploadImageRequest.uploadSucceeded && uploadImageRequest.res !== null) {
                setReturnedFilePath(uploadImageRequest.res.data.path);
                setFileUploaded(true);
                handleOnChange(uploadImageRequest.res.data.path)
            }
        }
    }

    const editImage = () => {
        setFileUploaded(false);
    }


    if (fileUploaded) {
        return <InputGroup className="mb-3">
            <Form.Control type="text"
                          id={id}
                          value={returnedFilePath}
                          disabled
            />
            <Button variant="success" id="button-addon1" onDoubleClick={editImage}><i
                className='fas fa-check'/></Button>
        </InputGroup>
    } else {
        return <>
            <OverlayTrigger placement="top" overlay={
                <ToolTip id="button-tooltip">Files will be uploaded first when you press the upload button. The remote
                    path will then be saved as the entity property value. You must upload the image before saving the
                    entity.</ToolTip>}>
                <span className="m-1"><i className={`fa fa-info-circle`}/></span>
            </OverlayTrigger>
            <InputGroup className="mb-3">
                <Form.Control type="file"
                              id={"blah"}
                              onChange={saveFileSelected}
                              accept=".png,.jpeg,.jpg,.gif"
                              {...props} />
                <Button variant="success" id="button-addon1"
                        onClick={uploadFile}>
                    {uploadInProgress ? <Spinner animation="border" role="status"/> : <i className='fas fa-upload'/>}
                </Button>
            </InputGroup>

        </>
    }
};
